



























import { Component, Mixins, Prop } from 'vue-property-decorator';
import { dateTimeFormat } from '@/ts/DefaultTableConfigs';
import DateMethods from '@/mixins/DateMethods.vue';
import {Actions, Mutations, ViewModes, Views} from '@/ts/store/Constants';

@Component({
    name: 'EventCardTexts',
})
export default class EventCardTexts extends Mixins(DateMethods) {
    @Prop({ default: '' }) public title: string;
    @Prop({ default: '' }) public text: string;
    @Prop({ default: '' }) public date: string;
    @Prop({ required: true }) public notificationId: number;
    @Prop({ default: null }) public eventId: number | null;
    @Prop({ required: true }) public type: string;
    @Prop({ required: true }) public seen: boolean;

    constructor() {
        super();
    }

    get parsedFormat() {
        return dateTimeFormat;
    }

    public open() {
        const routeName   = this.type === 'information' ? 'notification' : 'event';
        const routeQuery  = this.type === 'information' ? null : { notification: this.notificationId.toString() };
        const routeParams = this.type === 'information'
            ?  { notificationId: this.notificationId.toString() }
            :  { eventId: this.eventId.toString() };

        if (!this.seen) {
            this.$store.dispatch(Actions.MARK_TENANT_NOTIFICATION_AS_SEEN, this.notificationId);
        }

        if (this.type === 'information') {
            this.$store.commit(Mutations.SET_VIEW, {
                view: Views.Notifications,
                viewMode: ViewModes.Notifications.InformationView,
            });
        }

        this.$emit('openNotification', {routeName, routeParams, routeQuery});
    }

    public filterText(text: string): string {
        let filtered = text.replace(/<iframe[^>]+>.*?<\/iframe>/gm, '');
        filtered = filtered.replace(/<img.*?src="(.*?)"[^\>]+>/gm, '');

        return filtered;
    }
}
